import React, { MouseEvent, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";

export interface dataSourceProps {
  realName: string;
  saveName: string;
}

export interface ArcDownloadProps {
  dataSource: dataSourceProps[];
  onDownload: (res: dataSourceProps) => void
  isCntr?: boolean
  isLine?: boolean
}

export default function ArcDownload(props: ArcDownloadProps) {
  const { t } = useTranslation();

  const [uploadedFiles, setUploadedFiles] = useState(props.dataSource);
  useEffect(() => {
    setUploadedFiles(props.dataSource);
  }, [props.dataSource]);

  const downloadFile = (event: MouseEvent, filename: dataSourceProps) => {
    event.preventDefault();
    props.onDownload(filename);
  };

  return (
    <div className="mgb5">
      <div className="grid-sort mgb5 mgt10" style={{ alignItems: 'center' }}>
        <div className="paging pdt0" style={{ alignItems: 'center' }}>
          <span>
            {t('common.label.total-alt')}
            <strong>{(uploadedFiles.length ?? 0)}개</strong>
            {(uploadedFiles.length === 0) && (
              <em className="mgl20">업로드된 파일이 없습니다.</em>
            )}
          </span>
        </div>
      </div>
      <div>
        <ul className="box-graph1" style={{ gap: '0.2rem' }}>
          {(uploadedFiles?.length > 0) && (
            <ul className="box-graph1" style={{ gap: '0.2rem' }}>
              {uploadedFiles.map((file: dataSourceProps) => (
                <li key={file.saveName}>
                  <div className="box-style1 flexWrap pdt10 pdb10 mgt0">
                    <div>
                      <i className="xi-file-o mgr10" aria-hidden></i>
                      <strong className="al" style={{ whiteSpace: 'break-spaces'}}>
                        {decodeURIComponent(file.realName)}{' '}
                      </strong>
                    </div>
                    <a className="fs14 mgl3 ar"
                       onClick={(e) => downloadFile(e, file)}
                       style={{ minWidth: '3.7rem' }}
                    >
                      <i className="xi-download" aria-hidden>
                        <span>다운로드</span>
                      </i>
                    </a>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </ul>
      </div>
    </div>
  );
}